import { render, staticRenderFns } from "./ChangePolicyForm.vue?vue&type=template&id=3f93cbe1"
import script from "./ChangePolicyForm.vue?vue&type=script&lang=js"
export * from "./ChangePolicyForm.vue?vue&type=script&lang=js"
import style0 from "./ChangePolicyForm.vue?vue&type=style&index=0&id=3f93cbe1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports